'use strict';

import { h } from 'preact';
import { Component, PropTypes } from 'react';

const ThemeHoC = (WrappedComponent) => {
    return class ThemeComponent extends Component {
        static contextTypes = {
            theme: PropTypes.object.isRequired
        }

        render () {
            const { theme } = this.context;
            return (
                <WrappedComponent { ...this.props } theme={theme} />
            );
        }
    };
};
export default ThemeHoC;



// WEBPACK FOOTER //
// ./src/components/hoc/theme.js